import { Stack } from '../../../components/stack';

export const Root = ({ children }: React.PropsWithChildren) => (
  <Stack
    direction="row"
    sx={{
      position: 'relative',
      overflow: 'hidden',
      height: '100vh',
      width: '100vw',
    }}
  >
    {children}
  </Stack>
);
